/**
 * 获取舱位类型术语名词
 * 英语 => 中文
 * 中文 => 英语
 * @param {string} key
 * @returns {string}
 */
export default function getCabinTypeName(key) {
    switch (key) {
        case 'Business':
            return '公务舱';
        case '公务舱':
            return 'Business';
        case 'Economy':
            return '经济舱';
        case '经济舱':
            return 'Economy';
        case 'First':
            return '头等舱';
        case '头等舱':
            return 'First';
        case 'PremiumEconomy':
            return '明珠经济舱';
        case '明珠经济舱':
            return 'PremiumEconomy';
        default:
            break;
    }
}



//////////////////
// WEBPACK FOOTER
// ../emp-helpers/dist/es/business/getCabinTypeName.js
// module id = null
// module chunks = 